export const toDateInputValue = (value: unknown): string => {
    if (!value) {
        return '';
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
        return value.toISOString().slice(0, 10);
    }

    if (typeof value === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return value;
        }

        const parsedDate = new Date(value);
        return isNaN(parsedDate.getTime()) ? '' : parsedDate.toISOString().slice(0, 10);
    }

    return '';
};

export const toTimeInputValue = (value: unknown): string => {
    if (!value) {
        return '';
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
        const hours = String(value.getHours()).padStart(2, '0');
        const minutes = String(value.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    if (typeof value === 'string') {
        if (/^\d{2}:\d{2}$/.test(value)) {
            return value;
        }

        if (/^\d{2}:\d{2}:\d{2}$/.test(value)) {
            return value.slice(0, 5);
        }

        const parsedDate = new Date(value);
        if (!isNaN(parsedDate.getTime())) {
            const hours = String(parsedDate.getHours()).padStart(2, '0');
            const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
            return `${hours}:${minutes}`;
        }
    }

    return '';
};
